<div id="appointmentPicker" ng-cloak>

  <!-- TODO: Is there a way to not have this date hard-coded? -->
  <div [hidden]="!isResidentialAppointmentType()"><b>International tax appointments begin March 1st.</b></div>

  <div [hidden]="hasAvailability">Sorry! There are currently no remaining appointments available.</div>
  <div id="datePicker"
    class="form-textfield"
    [hidden]="!hasAvailability">
    <mat-form-field class="example-full-width">
      <label class="form-label form-required">Date</label>
      <input matInput [matDatepickerFilter]="dateFilter" [matDatepicker]="picker" [(ngModel)]="appointmentPickerSharedProperties.selectedDate" (ngModelChange)="dateChanged($event)" (changed)="dateChanged($event)" >
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <div [hidden]="selectedDate != null">
      <label class="error" [hidden]="isLoggedIn">This field is required.</label>
    </div>
  </div>
  <div id="sitePicker"
    class="form-select"
    [hidden]="appointmentPickerSharedProperties.selectedDate == null">
    <label class="form-label form-required" for="sitePickerSelect">Location <span class="required_asterisk" aria-hidden="true">*</span></label>
    <select id="sitePickerSelect"
      class="dcf-input-select dcf-mb-0"
      name="sitePickerSelect"
      [(ngModel)]="appointmentPickerSharedProperties.selectedSite"
      (ngModelChange)="siteChanged($event)"
      (changed)="siteChanged($event)"
      required>
      <option [ngValue]="undefined" style="display:none;" selected>-- Select a Location --</option>
      @for (site of sites; track site) {
        <option
          [ngValue]="site.id">
          {{ site.title }}
        </option>
      }
    </select>
    <div [hidden]="appointmentPickerSharedProperties.selectedDate != null">
      <label class="error" [hidden]="selectedSite != null">This field is required.</label>
    </div>
  </div>

  <div id="timePicker"
    class="form-select"
    [hidden]="appointmentPickerSharedProperties.selectedDate == null || appointmentPickerSharedProperties.selectedSite === null">
    <label class="form-label form-required" for="timePickerSelect">Appointment Time <span class="required_asterisk" aria-hidden="true">*</span></label>
    <div [hidden]="!hasAppointments()">
      <select id="timePickerSelect"
        class="dcf-input-select dcf-mb-0"
        name="timePickerSelect"
        [(ngModel)]="appointmentPickerSharedProperties.selectedTime"
        (changed)="updateSharedPicker()"
        (ngModelChange)="updateSharedPicker()"
        (changed)="updateSharedPicker()"
        required>
        <option [ngValue]="'undefined'" style="display:none;">-- Select a Time --</option>
        @for (time of times; track time) {
          <option
            [ngValue]="time.id">
            {{ time.time }}
          </option>
        }
      </select>
      <div [hidden]="appointmentPickerSharedProperties.selectedTime != null">
        <label class="error">This field is required.</label>
      </div>
    </div>
    <div [hidden]="hasAppointments()">There are no available timeslots remaining.</div>
  </div>
</div>
